module.exports = __webpack_public_path__ + "static/media/avatar1.c7bc6002.png";